// External link detection and warning
window.externalLinkHandler = {
    _dotNetHelper: null,
    _initialized: false,

    init: (dotNetHelper) => {
        // Always update the helper reference (in case the old one was disposed)
        window.externalLinkHandler._dotNetHelper = dotNetHelper;

        // Only add the event listener once
        if (window.externalLinkHandler._initialized) {
            return;
        }
        window.externalLinkHandler._initialized = true;

        // Function to check if a URL is external
        const isExternalLink = (url) => {
            try {
                // If it doesn't start with http:// or https://, it's not an external link
                if (!url.startsWith('http://') && !url.startsWith('https://')) {
                    return false;
                }
                
                const link = new URL(url);
                return link.hostname !== window.location.hostname;
            } catch (e) {
                return false;
            }
        };

        // Intercept clicks on all anchor tags
        document.addEventListener('click', async (e) => {
            // Find the anchor element (in case click was on a child element)
            let target = e.target;
            while (target && target.tagName !== 'A') {
                target = target.parentElement;
            }

            // Check if we found an anchor element with an href
            if (target && target.tagName === 'A' && target.href) {
                // Allow specific links to opt out of interception (e.g., the modal's Continue link)
                if (target.hasAttribute('data-external-link-handler') && target.getAttribute('data-external-link-handler') === 'ignore') {
                    return;
                }

                const href = target.getAttribute('href');
                
                // Only process if:
                // 1. href starts with http:// or https:// (absolute URL)
                // 2. It's actually pointing to a different domain
                if (href && (href.startsWith('http://') || href.startsWith('https://')) && isExternalLink(href)) {
                    e.preventDefault();
                    e.stopPropagation();
                    
                    // Try to invoke the Blazor method, handling disposed references gracefully
                    const helper = window.externalLinkHandler._dotNetHelper;
                    if (helper) {
                        try {
                            await helper.invokeMethodAsync('ShowExternalLinkWarning', href);
                        } catch (error) {
                            // If the reference is disposed or there's a connection issue,
                            // fall back to direct navigation
                            console.warn('External link handler: Blazor interop failed, navigating directly.', error);
                            window.externalLinkHandler.navigateToExternal(href);
                        }
                    } else {
                        // No helper available, navigate directly
                        window.externalLinkHandler.navigateToExternal(href);
                    }
                }
            }
        }, true);
    },

    navigateToExternal: (url) => {
        // Use a temporary anchor element instead of window.open()
        // This approach works reliably across all browsers including iOS Safari
        // where window.open() fails when not in the synchronous user gesture chain
        const anchor = document.createElement('a');
        anchor.href = url;
        anchor.target = '_blank';
        anchor.rel = 'noopener noreferrer';
        
        // Temporarily add to DOM, click, then remove
        anchor.style.display = 'none';
        document.body.appendChild(anchor);
        anchor.click();
        document.body.removeChild(anchor);
    },

    // Allow cleanup/reset if needed
    dispose: () => {
        window.externalLinkHandler._dotNetHelper = null;
    }
};
